import axios from '@/axios'
import moment from 'moment'

export default {
  getPatients({ commit }, payload) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .get('/patient', {
          params: payload
        })
        .then(function(response) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          commit('SET_STATE', {
            action: 'patients',
            data: response.data.data
          })
          commit('SET_STATE', {
            action: 'total',
            data: response.data.totalCount
          })
          commit('SET_STATE', {
            action: 'FilteredCount',
            data: response.data.FilteredCount
          })
          resolve({
            data: response.data.data,
            FilteredCount: response.data.FilteredCount,
            total: response.data.totalCount
          })
        })
        .catch(function(error) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          reject(error.message)
        })
    })
  },

  // get reward seyup history
  getRewardSetupHistory({ commit }, { id, payload }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    return new Promise(async (resolve, reject) => {
      await axios
        .get(`/patient/reward-history/${id}`, {
          params: {
            ...payload
          }
        })
        .then(function(response) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          commit('SET_STATE', {
            action: 'rewardSetupHistory',
            data: response.data.data
          })
          commit('SET_STATE', {
            action: 'totalRewardHistory',
            data: response.data.totalCount
          })

          resolve({
            data: response.data.data,
            total: response.data.totalCount
          })
        })
        .catch(function(error) {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          reject(error.message)
        })
    })
  },

  insert({ commit }, payload) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    return new Promise(async (resolve, reject) => {
      await axios
        .post('/patient', payload)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.message.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(`/patient/${id}`)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            message
          })
        })
    })
  },
  get(_, id) {
    return new Promise(async (resolve, reject) => {
      await axios
        .get(`/patient/${id}`)
        .then(res => {
          resolve({
            data: res.data,
            message: res.data.message
          })
        })
        .catch(err => {
          const message = Object.keys(err.response.data.meta) ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            message
          })
        })
    })
  },
  update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/patient/${id}`, data)
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  updateStatus({ commit }, { id, status }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    return new Promise(async (resolve, reject) => {
      await axios
        .put(`/patient/${id}/update-status`, {
          status
        })
        .then(res => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          resolve({
            data: res.data.data,
            message: res.data.message
          })
        })
        .catch(err => {
          commit('SET_STATE', {
            action: 'loading',
            data: false
          })
          const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
          reject({
            errors: Object.values(err.response.data.meta),
            message
          })
        })
    })
  },
  async bulkDelete({ commit }, { ids }) {
    const accessToken = localStorage.getItem('accessToken')
    const options = {
      method: 'DELETE',
      url: '/patient',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer  ${accessToken}`
      },
      data: { ids }
    }
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      const { data } = await axios.request(options)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: data.message }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  },
  async importCsv({ commit }, payload) {
    const accessToken = localStorage.getItem('accessToken')
    const options = {
      method: 'POST',
      url: '/patient/import',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer  ${accessToken}`
        // 'content-type': 'multipart/form-data; boundary=---011000010111000001101001'
      },
      data: payload
    }
    try {
      commit('SET_STATE', {
        action: 'loading',
        data: true
      })
      const { data } = await axios.request(options)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return { message: data.message, data: data.patients }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const message = Object.keys(err.response.data.meta).length ? Object.values(err.response.data.meta)[0] : err.response.data.message
      return Promise.reject({ message })
    }
  }
}
